import { isImmutable, fromJS } from 'immutable'

export function forceImmutable (obj) {
  return isImmutable(obj)
    ? obj
    : fromJS(obj)
}



// WEBPACK FOOTER //
// ./client/src/util/immutableUtils.js